exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row-pointer tbody tr{cursor:pointer}.force-full-height{height:100vh!important;width:100vw!important}.darker-text{color:#111!important}.shady-box{height:125px;min-height:125px;max-height:125px}@page{size:letter landscape}@media print{body,html{font-size:10pt;margin-top:-50px}body{margin:0;padding:0}.print-half-page{height:47vh;box-sizing:border-box;overflow:hidden;page-break-inside:avoid}.shady-box{height:108px;min-height:108px;max-height:108px}.page-title{margin-bottom:0}.print-container:first-of-type{margin-top:-38px!important}}", ""]);

// exports
